var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "314px",
    height: "97px",
    viewBox: "0 0 314 97",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.54992629%",
    y1: "55.9452405%",
    x2: "100%",
    y2: "55.9452405%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#0DC597",
    cx: 258.5,
    cy: 52.5,
    r: 30.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.558673,33.6017514 C248.500924,36.4117093 259,48.7297593 259,63.5 C259,70.6371894 256.548509,77.2018022 252.441633,82.3977315 C238.499076,79.5882907 228,67.2702407 228,52.5 C228,45.4252324 230.408798,38.9130695 234.450992,33.7389125 L234.558673,33.6017514 Z",
    id: "Combined-Shape",
    fill: "#00B38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,75 L47.000905,74.9741828 C36.9719149,74.4546221 29,66.1582813 29,56 C29,45.6194221 37.3246359,37.1831671 47.6622002,37.0029425 L48,37 L48.0029425,36.6622002 C48.1831671,26.3246359 56.6194221,18 67,18 C74.7664341,18 81.4445181,22.6597811 84.390947,29.3360383 C87.4434129,28.465798 90.66731,28 94,28 C113.329966,28 129,43.6700338 129,63 C129,72.9966456 123.480392,74.6655476 106.001313,74.9441644 L106,75 L47,75 Z",
    id: "Combined-Shape",
    fill: "#0DC597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5,31 C80.7686294,31 101.523893,50.3240173 103.794032,75.000294 L47,75.000294 L47.000905,74.9741828 C36.9719149,74.4546221 29,66.1582813 29,56 C29,45.6194221 37.3246359,37.1831671 47.6622002,37.0029425 L48,37 L48.0029425,36.6622002 C48.034459,34.8544372 48.3184501,33.1082308 48.8211626,31.4573344 C51.0041665,31.15541 53.2339343,31 55.5,31 Z",
    id: "Combined-Shape",
    fill: "#00B38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,88.5 C275,63.3710439 218.811736,53.000147 149.5,53.000147 C80.1882639,53.000147 24,63.3710439 24,88.5 C24,88.5 275,88.5 275,88.5 Z",
    id: "Oval",
    fill: "#1AD6A3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(18.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-8",
    fill: "url(#linearGradient-1)",
    points: "49.100226 39.5505997 2.84217094e-14 44.8463172 2.84217094e-14 69.5505997 49.100226 49.5505997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5978484,32.6554008 L87.7115096,26.4916724 C90.0517893,25.978582 92.1605627,24.7154469 93.7173044,22.8942588 L109.993992,3.85262085 C112.083874,1.40772698 115.139128,0 118.355509,0 L174.144872,0 C177.315717,0 180.332329,1.36830088 182.421056,3.75398183 L200.123855,23.9735858 C201.121335,25.1128778 202.343298,26.0339548 203.713222,26.6791378 L214.113602,31.5773269 C217.96736,33.3923028 220.426785,37.2691327 220.426785,41.528897 L220.426785,58.5505997 C220.426785,64.625732 215.501917,69.5505997 209.426785,69.5505997 L61.953571,69.5505997 C55.8784387,69.5505997 50.953571,64.625732 50.953571,58.5505997 L50.953571,43.4001936 C50.953571,38.2328028 54.5503445,33.7620316 59.5978484,32.6554008 Z",
    id: "Rectangle",
    stroke: "#0149D5",
    strokeWidth: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.238327,7.55059971 L167.985417,7.55059971 C169.680662,7.55059971 171.260441,8.40957625 172.182032,9.83243445 L179.954483,21.8324345 C181.455684,24.1501609 180.793759,27.2460135 178.476033,28.7472147 C177.666439,29.2715925 176.722448,29.5505997 175.757868,29.5505997 L110.882879,29.5505997 C108.121456,29.5505997 105.882879,27.3120235 105.882879,24.5505997 C105.882879,23.6282989 106.137981,22.7239694 106.619969,21.9376323 L113.975417,9.93763227 C114.884439,8.45461279 116.498882,7.55059971 118.238327,7.55059971 Z",
    id: "Rectangle",
    stroke: "#0149D5",
    strokeWidth: 5,
    fill: "#8FDBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0149D5",
    strokeWidth: 5,
    fill: "#CED2D9",
    cx: 183.953571,
    cy: 66.5505997,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#0149D5",
    cx: 183.953571,
    cy: 66.5505997,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0149D5",
    strokeWidth: 5,
    fill: "#CED2D9",
    cx: 87.953571,
    cy: 66.5505997,
    r: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.953571,
    y1: 8.55059971,
    x2: 160.605556,
    y2: 29.5505997,
    id: "Path-2",
    stroke: "#0149D5",
    strokeWidth: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#0149D5",
    cx: 87.953571,
    cy: 66.5505997,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.953571,49.5505997 C57.953571,49.5505997 57.953571,39.5505997 57.953571,39.5505997 C55.1921472,39.5505997 52.953571,41.789176 52.953571,44.5505997 C52.953571,47.3120235 55.1921472,49.5505997 57.953571,49.5505997 Z",
    id: "Oval",
    fill: "#0149D5",
    transform: "translate(55.453571, 44.550600) scale(-1, 1) translate(-55.453571, -44.550600) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.953571,50.5506003 C217.953571,50.5506003 217.953571,40.5506003 217.953571,40.5506003 C215.192147,40.5506003 212.953571,42.7891766 212.953571,45.5506003 C212.953571,48.3120241 215.192147,50.5506003 217.953571,50.5506003 Z",
    id: "Oval",
    fill: "#FF5E61",
    transform: "translate(215.453571, 45.550600) scale(-1, 1) rotate(-180.000000) translate(-215.453571, -45.550600) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.953571,61.5506003 C226.953571,61.5506003 226.953571,51.5506003 226.953571,51.5506003 C224.192147,51.5506003 221.953571,53.7891766 221.953571,56.5506003 C221.953571,59.3120241 224.192147,61.5506003 226.953571,61.5506003 Z",
    id: "Oval",
    fill: "#0149D5",
    transform: "translate(224.453571, 56.550600) rotate(-180.000000) translate(-224.453571, -56.550600) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "#0149D5",
    strokeWidth: 5,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "146.508886 39.7165616 147.953571 37.5505997 156.054864 37.5505997"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.6005051,77.636039 C58.2277737,75.0087704 62.0752506,74.3453973 65.318713,75.6459199 L65.318713,75.6459199 L65.3962383,75.8464699 C66.5909737,79.0468377 65.9017033,82.7906849 63.3284271,85.363961 C60.7011585,87.9912296 56.8536816,88.6546027 53.610386,87.3542469 C53.5650372,87.2411486 53.5220764,87.1273159 53.4815034,87.0128261 C53.4423897,87.1273159 53.3994289,87.2411486 53.3540801,87.3542469 C50.1107845,88.6546027 46.2633076,87.9912296 43.636039,85.363961 C41.0627628,82.7906849 40.3734924,79.0468377 41.5682278,75.8464699 L41.6457531,75.6459199 C44.8892155,74.3453973 48.7366924,75.0087704 51.363961,77.636039 C52.3433713,78.6154492 53.0498594,79.7644315 53.4834254,80.9884801 C53.9146067,79.7644315 54.6210948,78.6154492 55.6005051,77.636039 Z",
    id: "Combined-Shape",
    fill: "#009987"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BEF7E5",
    x: 0,
    y: 88,
    width: 314,
    height: 6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainResult);
export default __webpack_public_path__ + "static/media/main-result.7b72b4b00e9bf424f9a02aac48c8830a.svg";
export { ForwardRef as ReactComponent };